import React from 'react';
import {
  CreateButton,
  FilterLiveSearch,
  TopToolbar,
  usePermissions,
  useTranslate
} from 'react-admin';
import { PrivilegeType } from '../../../core/models/privileges/privilegeType';
import { some } from '../../../core/utils/collection-utils';

export const PumpsListActions = () => {
  const t = useTranslate();
  const { permissions } = usePermissions();
  return (
    <TopToolbar>
      <FilterLiveSearch
        source="model"
        placeholder={t('resources.pumps.filters.search')}
      />
      {some([PrivilegeType.MANAGE_PUMPS], permissions) && (
        <CreateButton resource="/pumps" />
      )}
    </TopToolbar>
  );
};
